import { render, staticRenderFns } from "./CWave.vue?vue&type=template&id=e0166158&"
import script from "./CWave.vue?vue&type=script&lang=js&"
export * from "./CWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports